define('collections/manual_payments',['require','collections/base','models/credit_card'],function(require){

    var BaseCollection = require('collections/base');
    var Model = require("models/credit_card");

    return BaseCollection.extend({
        model: Model,
        url: 'manual-payments.json'
    });
});

